import type React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideAlert } from 'core/store/modules/common';
import { useShallowEqualSelector } from 'core/modules/hooks';
import type { StoreState } from 'core/types';

import type { NotificationPlacement } from 'core/components/ui';
import { notification } from 'core/components/ui';
import camelCase from 'lodash/camelCase';

export default function SystemAlerts() {
  const dispatch = useDispatch();
  const alerts = useShallowEqualSelector((s: StoreState) => s.app.alerts);

  useEffect(() => {
    alerts.forEach(({ id, variant, timeout, position, ...rest }) =>
      notification[variant]({
        key: id,
        duration: timeout,
        placement: camelCase(position) as NotificationPlacement,
        onClose: () => dispatch(hideAlert(id)),
        ...rest,
      }),
    );
  }, [alerts]);

  return null;
}
